/**
 * マーク・アイコンマスタ画面のアイコン変換情報一覧クラス
 *
 * @export CwsIconConvInfoForView
 * @class CwsIconConvInfoForView
 */
export class CwsIconConvInfoForView {
    constructor(
        public markCode: string,
        public markGroupName: string,
        public markName: string,
        public markCodeBranch: string,
        public markFileUrl: string,
        public iconFileName: string,
        public iconUrl: string
    ) { }
}
